"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupName = void 0;
var _react = require("react");
var _GroupName = require("./GroupName.styles");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _Modal = require("../../../../../Layout/Modal");
var _Button = require("../../../../../UI/Button");
var _Input = require("../../../../../UI/Input");
var _jsxRuntime = require("react/jsx-runtime");
const GroupName = props => {
  const {
    onCancel,
    onConfirm,
    createGroupTempData,
    setCreateGroupTempData,
    isEditMode = false
  } = props;
  const styles = (0, _GroupName.useStyles)(props);
  const getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  const {
    gender
  } = (0, _hooks.useSessionData)();
  const inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const handleChangeGroupName = val => {
    if (isEditMode) {
      setCreateGroupTempData({
        ...createGroupTempData,
        newGroupName: val
      });
    } else {
      setCreateGroupTempData({
        ...createGroupTempData,
        groupName: val
      });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel(isEditMode ? `input_new_group_name_${gender}` : `input_group_name_${gender}`)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-AudiencePicker__group-name'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
          id: "groupName",
          type: "text",
          value: createGroupTempData && createGroupTempData[isEditMode ? 'newGroupName' : 'groupName'],
          onChange: handleChangeGroupName,
          ariaLabel: getLabel('group_name'),
          placeholder: getLabel(`input_placeholder_${gender}`),
          ref: inputRef
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "link",
          id: "backButton",
          onClick: onCancel,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "confirmButton",
          onClick: onConfirm,
          isDisabled: !createGroupTempData || createGroupTempData[isEditMode ? 'newGroupName' : 'groupName']?.length === 0,
          children: getLabel('confirm')
        })
      })]
    })]
  });
};
exports.GroupName = GroupName;